// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3ES5M","title":"Images45_title__ILQFn","images":"Images45_images__2BfpG"};